// extracted by mini-css-extract-plugin
module.exports = {"h5button":"gl","h5Button":"gl","button":"gm","block":"gn","btnDefault":"go","disable":"gp","btnPrimary":"gq"};